import { Component, EventEmitter, forwardRef, inject, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { RegisterForm } from '../register-form.interface';
import { EmailValidator } from '../../../../shared/validators/email.validator';
import { FormStepAbstract } from '../../../../shared/components/abstract/form-step.abstract';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SafeHtmlPipe } from 'src/app/shared/pipes/safe-html/safe-html.pipe';
import { ConfigRepository } from 'src/app/shared/repositories/config.repository';

@Component({
  selector: 'app-dh-register-form',
  standalone: true,
  templateUrl: './dh-register-form.component.html',
  styleUrls: ['./dh-register-form.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DHRegisterFormComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DHRegisterFormComponent),
      multi: true,
    }
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    SafeHtmlPipe
  ]
})
export class DHRegisterFormComponent extends FormStepAbstract {
  @Output() submit: EventEmitter<unknown> = new EventEmitter<unknown>();
  
  configRepository = inject(ConfigRepository);

  fromRussia$ = this.configRepository.fromRussia$;
  personalDataPolicyPage$ = this.configRepository.personalDataPolicyPage$;
  personalDataConsentPage$ = this.configRepository.personalDataConsentPage$;
  additionalPrivacy$ = this.configRepository.additionalPrivacy$;
  
  override form: FormGroup<RegisterForm | null> = new FormGroup<RegisterForm | null>({
    email: new FormControl<string>('', { nonNullable: true, validators: [Validators.required, EmailValidator()] }),
    phone: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    name: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    acceptedPersonalDataProcessingPolicy: new FormControl<boolean>(true, { nonNullable: true, validators: [Validators.requiredTrue] }),
    acceptedMarketingCommunications: new FormControl<boolean>(false, { nonNullable: true }),
  });

  private message = $localize`:@@Agreement:I agree to %consentLink% the processing of personal data %link% and am familiar with %policyLink% the Personal Data Processing Policy %link%`;
  agreementMessage = this.message
    .replace('%consentLink%', `<a href="additional/personal-data-consent" target="_blank">`)
    .replace('%policyLink%', `<a href="additional/personal-data-policy" target="_blank">`)
    .replaceAll('%link%', `</a>`);

  agreementMessageDeprecated = this.message
    .replace('%consentLink%', ``)
    .replace('%link%', ``)
    .replace('%policyLink%', `<a href="additional/privacy-policy" target="_blank">`)
    .replace('%link%', `</a>`);
  
  onSubmit(event: KeyboardEvent): void {
    if (!event.shiftKey && (event.key === 'Enter')) {
      this.submit.emit();
    }
  }
}
